import { FunctionComponent, useRef, useState } from "react";
import { Icon } from "../../../Icon";
import useOnClickOutside from "../../../../utils/hooks/useOnClickOutside";
import UserDropDown from "../../../UserDropDown";

type Props = {};

const AdminSection: FunctionComponent<Props> = ({}) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const dropDownRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(dropDownRef, () => setDropDownOpen(false));

  const handleDropDown = () => {
    setDropDownOpen(!dropDownOpen);
  };

  return (
    <div className="nav_user" onClick={handleDropDown} ref={dropDownRef}>
      <p className="nav_user__button">RT</p>
      <Icon iconName="down_arrow" className="nav_user__arrow" />
      {dropDownOpen && <UserDropDown setIsOpen={setDropDownOpen} />}
    </div>
  );
};

export default AdminSection;
